import slick from 'slick-carousel';

const defaultParams = {}

class Testimonials {
    constructor(selector, params) {
        this.selector = selector;
        this.params = $.extend({}, defaultParams, params)
        this.$slider = null;
        this.$window = $(window);
    }

    init() {
        $().ready(() => {
            this.$slider = $(this.selector);
            if (this.$slider.length === 0)
                return;

            this.$slider.slick({
                adaptiveHeight: false,
                infinite: true,
                dots: true,
                arrows: false,
                autoplay: true,
                fade: true,
                speed: 500,
                pauseOnFocus: true,
                autoplaySpeed: 25000,
                appendDots: '.dots'
            });
        });
    }


}

export { Testimonials as default };
